export const keys: (keyof CreateCampaignObjectiveBasedFormData)[] = ['goal']

export const validator = (
  formData: Partial<CreateCampaignObjectiveBasedFormData>
) => {
  if (!['profitability', 'growth', 'reach'].includes(formData['goal'])) {
    return false
  }

  return true
}
